import React from "react";
import { useSelector } from "react-redux";
import "../../../styles/broadcast-system/review-form.css";
import CloseSubmitBtn from "../custom-comps/CloseSubmitBtn";
import {
  filterKeyToLabel,
  getFilterValue,
  replaceTemplateVariablesWithLabels,
} from "./BroadcastMocks";

const ReviewTemplateForm = ({
  allFilters,
  selectedMembers,
  formValues,
  handleBack,
  variables,
  handleSubmitFormOnNextClick,
}) => {
  const { postPutLoading } = useSelector((state) => state.common);

  const handleSendBroadcast = () => {
    handleSubmitFormOnNextClick();
  };

  return (
    <>
      <div className="review-grid">
        <div className="review-card">
          <div className="applied-filters">
            <h3>Applied Filters</h3>

            {Object.keys(allFilters || {}).length === 0 ? (
              <div className="recipient">
                <span className="dot" /> No filters applied
              </div>
            ) : (
              <div className="scrollable-list">
                {Object.entries(allFilters || {}).map(([key, val]) => {
                  if (key === "selectedGym" || key === "selectedGyms")
                    return null;

                  const displayValue = getFilterValue(val);
                  if (!displayValue) return null;

                  return (
                    <div key={key} className="filter-row">
                      <span className="filter-label">
                        {filterKeyToLabel(key)}:
                      </span>
                      <span className="filter-value">{displayValue}</span>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        <div className="review-card">
          <h3>Applied Gyms - {allFilters?.selectedGyms?.length || 0}</h3>

          {(allFilters?.selectedGyms?.length ?? 0) === 0 ? (
            <div className="recipient">
              <span className="dot" /> No gym selected
            </div>
          ) : (
            <div className="scrollable-list">
              {allFilters?.selectedGyms.map((gym, i) => (
                <div key={i} className="recipient">
                  <span className="dot" /> {gym.label}
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="review-card">
          <h3>Selected Members - {selectedMembers?.length || 0}</h3>

          {selectedMembers?.length === 0 ? (
            <div className="recipient">
              <span className="dot" /> No members selected
            </div>
          ) : (
            <div className="scrollable-list">
              {selectedMembers?.map((r, i) => (
                <div key={i} className="recipient">
                  <span className="dot" /> {r.label}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <br />

      <div className="review-grid grid-2">
        {formValues.isWhatsaap && (
          <div className="review-card">
            <h3>Whatsapp Message Preview</h3>
            <div className="message-preview">
              <div className="whatsapp-bubble">
                {formValues.selectedWPTemplate?.label}
              </div>
              <div className="message-note">
                {/* {formValues.selectedWPTemplate?.info?.body} */}
                {replaceTemplateVariablesWithLabels(
                  formValues.selectedWPTemplate?.info?.body,
                  formValues.selectedWPTemplateVariables,
                  variables
                )}
              </div>
            </div>
          </div>
        )}

        {formValues.isPush && (
          <div className="review-card">
            <h3>Push Notification Preview</h3>
            <div className="message-preview">
              <div className="whatsapp-bubble">
                {replaceTemplateVariablesWithLabels(
                  formValues.pushTitle,
                  formValues.selectedPushTemplateVariables,
                  variables
                )}
              </div>
              <div className="message-note">
                {replaceTemplateVariablesWithLabels(
                  formValues.pushBody,
                  formValues.selectedPushTemplateVariables,
                  variables
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      <CloseSubmitBtn
        closeLabel="Back"
        submitLabel={"Send Broadcast"}
        onClose={handleBack}
        // onSubmit={handleSubmitFormOnNextClick}
        onSubmit={handleSendBroadcast}
        isLoading={postPutLoading}
      />
    </>
  );
};

export default ReviewTemplateForm;
